export default __webpack_public_path__ + "static/media/delete.04425845.svg";